import { FormGroup } from "@angular/forms";

export abstract class NdmsUtils {
    static initObj(instance: any, initializer?: any) {
        // return if no initializer is passed in
        if (initializer === undefined) {
            return;
        }
        // apply 
        Object.keys(initializer).forEach((key, index) => {
            instance[key] = initializer[key];
        });
    }

    static pluck(instance: any, ...properties: string[]) {
        var object: any = {};

        for( let i = 0; i < properties.length; i++) {
            object[properties[i]] = instance[properties[i]];
        }

        return object;
    }

    static touchAllFields(form: FormGroup) {
        Object.keys(form.controls).forEach(key => {
            let control = form.get(key);
            if (control) {
                control.markAsTouched();
            }
        });
    }
}